'use client';

import { Button } from '@/components/common/Button/Button';
import { ReactNode } from 'react';
import styles from './StartOrderAddressCard.module.css';

export interface StartOrderAddressCardProps {
	missingAddr?: string;
	title?: string;
	label?: string;
	leftIcon?: ReactNode;
	rightIcon?: ReactNode;
	addressChildren?: ReactNode;
	disabled?: boolean;
	ctaAction?: () => void;
	fromConfirmPage?: boolean;
	doordashIcon?: ReactNode;
	getDirectionLink?: ReactNode;
}

export function StartOrderAddressCard({
	missingAddr,
	title,
	label,
	leftIcon,
	rightIcon,
	addressChildren,
	disabled = false,
	ctaAction,
	fromConfirmPage,
	doordashIcon,
	getDirectionLink,
	...props
}: StartOrderAddressCardProps) {
	return (
		<div
			className={`${fromConfirmPage ? styles.doorDashIcon : styles.startOrderAddressCard} ${disabled ? 'opacity-50' : ''}`}
			{...props}
		>
			<Button
				disabled={disabled}
				variant="text"
				className="col-start-1 col-end-12 flex w-full justify-between gap-2.5"
				style={{ cursor: !disabled && ctaAction ? 'pointer' : 'default' }}
				onClick={() => {
					ctaAction?.();
				}}
			>
				{leftIcon}
				<div className="me-auto pt-1 text-left">
					{label && (
						<p className={`${styles.addressBody}`} data-type-style="label">
							{label}
						</p>
					)}

					{title && !fromConfirmPage ? (
						<p className="pb-1 font-black uppercase" data-type-style="subtitle-3" data-ink="medium">
							{title}
						</p>
					) : (
						<></>
					)}

					{/* Display title for confirm order screen  */}
					{fromConfirmPage && title && (
						<p
							className="highlight-mask pb-1 font-black uppercase"
							data-type-style="subtitle-4"
							data-ink="base"
						>
							{title}
						</p>
					)}

					{missingAddr ? (
						<p className="text-sm" data-type-style="body-3" data-ink="base">
							{missingAddr}
						</p>
					) : (
						<>{addressChildren}</>
					)}
					{getDirectionLink}
				</div>
			</Button>
			{rightIcon}
			{doordashIcon}
		</div>
	);
}
